import { Routes, Route, BrowserRouter } from "react-router-dom";
import Layout from "./Main-Component/Layout";
import Home from "./Components/Home";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Service from "./Components/Service";
import Terms from "./Components/Terms";
import PrivacyPolicy from "./Components/Policy";
import CancellationPolicy from "./Components/CancellationPolicy";

// ---------------Admin pannel --------------------------------------------------
import AdminLogin from "./Admin-Pannel/Admin-Component/AdminLogin";
import AdminDashboard from "./Admin-Pannel/Admin-Component/AdminDashboard";
import AdminLayout from "./Admin-Pannel/Admin-Component/AdminLayout";
import ProtectedRoute from "./Admin-Pannel/Admin-Component/ProtectedRoute";
import SliderForm from "./Admin-Pannel/Admin-Component/SliderForm";
import ContactUsForm from "./Admin-Pannel/Admin-Component/ContactPreviw";
import SliderPreview from "./Admin-Pannel/Admin-Component/SliderPreview";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="service" element={<Service />} />
            <Route path="terms" element={<Terms />} />
            <Route path="policy" element={<PrivacyPolicy />} />
            <Route path="cancellationPolicy" element={<CancellationPolicy />} />
          </Route>

          <Route path="/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="/admin/admindashboard" element={<AdminDashboard />} />
            <Route path="/admin/sliderForm" element={<SliderForm />} />
            <Route path="/admin/contact" element={<ContactUsForm />} />

            <Route
              path="/admin/sliderForm-Preview"
              element={<SliderPreview />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
